import 'css-chunksrc/client/common/dateTimePicker/styles.scss';export default {
  "dateTimePicker": "_dateTimePicker_1pva4_1",
  "input": "_input_1pva4_6",
  "placeholder": "_placeholder_1pva4_22",
  "value": "_value_1pva4_27",
  "calendarInput": "_calendarInput_1pva4_32",
  "calendar": "_calendar_1pva4_32",
  "timeList": "_timeList_1pva4_48",
  "timeListWrapper": "_timeListWrapper_1pva4_57",
  "time": "_time_1pva4_48",
  "timeName": "_timeName_1pva4_69",
  "invalid": "_invalid_1pva4_75",
  "timeInput": "_timeInput_1pva4_80",
  "readOnly": "_readOnly_1pva4_94"
};